import { useAuthStore } from '@/stores/authStore';

export function useAuth() {
  const session = useAuthStore((s) => s.session);
  const user = useAuthStore((s) => s.user);
  const loaded = useAuthStore((s) => s.loaded);
  const authEvent = useAuthStore((s) => s.authEvent);
  const profile = useAuthStore((s) => s.profile);
  const profileLoaded = useAuthStore((s) => s.profileLoaded);
  return {
    session,
    user,
    loaded,
    authEvent,
    profile,
    profileLoaded,
    isAuthenticated: !!session,
  };
}
